module.exports = __webpack_public_path__ + "fonts/ionicons.1fa6a1e.ttf";